import { connect } from 'react-redux';

import { ExpiredContent } from '../../components/ExpiredContent';
import { IAppState } from '../../reducers';
import { getPageBlocks } from '../../utils/commonSelectors';

interface IExpiredContentContainer {
  addYaTGO?: string;
}

function mapStateToProps(state: IAppState, ownProps: IExpiredContentContainer) {
  const blocks = getPageBlocks(state);

  return { blocks, addYaTGO: ownProps.addYaTGO };
}

export const ExpiredContentContainer = connect(mapStateToProps)(ExpiredContent);
